module.exports = __webpack_public_path__ + "img/P8_popup_thumb_1_en.35e46d5a.png";